/**
 * Função que executa o fluxo de download de dados;
 * @param nomeArquivo É necessário que o nome do arquivo tenha extensão;
 * @param arquivo Base64 dos dados;
 */
export const downloadBase64File = async (nomeArquivo: string, arquivo: string): Promise<void> => new Promise((accept, reject) => {
  try {
    const binaryString = window.atob(arquivo);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);

    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }

    const blob = new Blob([bytes], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    const newWindow = window.open(nomeArquivo, url, '_blank');

    const tempLink = document.createElement('a');

    tempLink.href = url;
    tempLink.download = nomeArquivo;

    document.body.appendChild(tempLink);

    tempLink.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(tempLink);

      if (newWindow) newWindow.close();

      accept();
    }, 0);
  } catch (e: unknown) {
    reject(e);
  }
});

export const downloadFromBlobUrl = async (blob: Blob, nomeArquivo: string): Promise<void> => new Promise((accept, reject) => {
  try {
    const url = window.URL.createObjectURL(blob);

    const newWindow = window.open(nomeArquivo, url, '_blank');

    const tempLink = document.createElement('a');

    tempLink.href = url;
    tempLink.download = nomeArquivo;

    document.body.appendChild(tempLink);

    tempLink.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(tempLink);

      if (newWindow) newWindow.close();

      accept();
    }, 1000);
  } catch (e: unknown) {
    reject(e);
  }
});

export const downloadFromBlob = async (blob: Blob, nomeArquivo: string): Promise<void> => new Promise((accept, reject) => {
  try {
    const url = window.URL.createObjectURL(blob);
    const newWindow = window.open(nomeArquivo, url, '_blank');

    const tempLink = document.createElement('a');

    tempLink.href = url;
    tempLink.download = nomeArquivo;

    document.body.appendChild(tempLink);

    tempLink.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(tempLink);

      if (newWindow) newWindow.close();

      accept();
    }, 0);
  } catch (e: unknown) {
    reject(e);
  }
});
